import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

const searchSchema = z.object({
  year: z.coerce.number().int().optional().catch(undefined),
  month: z.coerce.number().int().min(1).max(12).optional().catch(undefined),
});

/** The old overview; bookmarks and the installed PWA start URL land on Idag. */
export const Route = createFileRoute('/budget/')({
  validateSearch: searchSchema,
  beforeLoad: ({ search }) => {
    throw redirect({ to: '/', search, replace: true });
  },
  component: () => null,
});
